import clsx from 'clsx';
import { Icon } from '@/design-system';
import { ns, useT } from '@/i18n';
import { useOverlays } from '../state/overlays';
import { useFormat } from '../state/preferences';
import { useVehicleSearch } from '../state/vehicleSearch';
import styles from './SearchPill.module.css';

/** The current vehicle search as a pill; opens the search sheet. Desktop (`.hp`) and mobile (`.hm-pill`). */
export function SearchPill({ mobile = false }: { mobile?: boolean }) {
  const { search, days } = useVehicleSearch();
  const { open } = useOverlays();
  const t = useT(ns.shell);
  const f = useFormat();
  const range = f.range(search.start, search.end);
  if (mobile) {
    return (
      <button type="button" className={styles.m} onClick={() => open('vehicleSearch')} aria-label={t('editSearch')}>
        <Icon name="search" size={17} strokeWidth={2.2} />
        <span className={styles.mText}>
          <b>{search.city}</b>
          <span>
            {range} · {f.days(days)}
          </span>
        </span>
      </button>
    );
  }
  return (
    <button type="button" className={styles.hp} onClick={() => open('vehicleSearch')} aria-label={t('editSearch')}>
      <span>{search.city}</span>
      <span className={clsx(styles.sep, styles.dates)} />
      <span className={styles.dates}>{range}</span>
      <span className={styles.sep} />
      <span className={styles.q}>{f.days(days)}</span>
      <span className={styles.go}>
        <Icon name="search" size={18} strokeWidth={2.4} />
      </span>
    </button>
  );
}
